import React from "react";

// A barra de uma linha, contra o maior valor da sua tabela, e o numero a seguir. A barra e so desenho.
const InlineBar = ({ value, max, text }) => (
  <span className="inline-flex items-center justify-end gap-2 w-full">
    <span aria-hidden="true" className="hidden sm:block h-2 w-24 rounded" style={{ backgroundColor: "var(--color-surface-raised)" }}>
      <span className="block h-2 rounded" style={{ width: `${max ? (100 * value) / max : 0}%`, backgroundColor: "var(--chart-1)" }} />
    </span>
    <span className="tabular-nums">{text}</span>
  </span>
);

export default InlineBar;
